import type { ValidationError } from 'vue-validate-form';
import { yupResolver } from '@vue-validate-form/resolvers';
import { setLocale, addMethod, string } from 'yup';
import type { ErrorsType, ErrorsVariant } from '@/shared/legacy/lib/util/normalize-errors';
import { translateErrors, getErrors } from '@/shared/legacy/lib/util/normalize-errors';
import { trlMessage } from '@/shared/lib/i18n';

export { ValidationProvider, ValidationFieldArray } from 'vue-validate-form';
export { yupResolver };
export { default as ValidationField } from './validation-field.vue';
export { default as ValidationErrors } from './validation-errors.vue';
export { default as FormField } from '../form-field/form-field.vue';

const VALID_EMAIL_REGEX = /^[^@\s]+@([^@\s]+\.)+[^@\s]{2,}$/i;

setLocale({
  mixed: {
    required: trlMessage('validation.error.required'),
    notType: ({ type }) => trlMessage('validation.error.type', { type })
  },
  array: {
    max: ({ max }) => trlMessage('validation.error.maxItems', { limit: max }),
    min: ({ min }) => trlMessage('validation.error.minItems', { limit: min })
  },
  string: {
    max: ({ max }) => trlMessage('validation.error.maxLength', { limit: max }),
    min: ({ min }) => trlMessage('validation.error.minLength', { limit: min }),
    url: trlMessage('validation.error.uri')
  },
  number: {
    max: ({ max }) => trlMessage('validation.error.maximum', { limit: max }),
    min: ({ min }) => trlMessage('validation.error.minimum', { limit: min })
  }
});

addMethod(string, 'email', function validateEmail(message = '') {
  return this.matches(VALID_EMAIL_REGEX, {
    message: message || trlMessage('error.not-correct-email'),
    name: 'email',
    excludeEmptyString: true
  });
});

export type SubmitErrorOptions = {
  setError: (name: string, error: ValidationError) => void;
  focusInvalidField: () => void;
};

export function setSubmitErrors(errors: ErrorsVariant, {
  onError,
  onFinish
}: {
  onError: (name: string, error: string) => void;
  onFinish: () => void;
}) {
  const translatedErrors = translateErrors(errors);
  Object.entries(translatedErrors).forEach(([key, values]) => {
    values.forEach((message) => {
      onError(key, message);
    });
  });
  onFinish();
}

export function setSubmitError(
  err: ErrorsType,
  { setError, focusInvalidField }: SubmitErrorOptions
): void {
  const errors = getErrors(err);

  Object.entries(errors).forEach(([key, values]) => {
    values.forEach((message) => {
      setError(key, {
        message,
        type: 'custom'
      });
    });
  });
  focusInvalidField();
}
